module.exports = __webpack_public_path__ + "static/media/background.524c9a81.png";